export class FullSlider {
  constructor({
    $slider,
    fnSelectSlides = ({ $slider }) => {
      return $slider.querySelectorAll('.slide');
    },
  }) {
    this.$slider = $slider;
    this.fnSelectSlides = fnSelectSlides;
  }

  scrollNext() {
    const currentSlideIndex = this._getCurrentSlideIndex();
    const $slides = this._getSlides();
    const newSlideIndex = currentSlideIndex >= $slides.length - 1 ? 0 : currentSlideIndex + 1;
    this.scrollTo(newSlideIndex);
  }

  scrollPrev() {
    const currentSlideIndex = this._getCurrentSlideIndex();
    const $slides = this._getSlides();
    const newSlideIndex = currentSlideIndex <= 0 ? $slides.length - 1 : currentSlideIndex - 1;

    this.scrollTo(newSlideIndex);
  }

  scrollTo(index) {
    const $slides = this._getSlides();
    if (!$slides || !$slides.length) return;
    const $slide = $slides[index];
    if (!$slide) return;

    const slidePosition =
      Math.round($slide.getBoundingClientRect().left) -
      Math.round(this.$slider.getBoundingClientRect().left);

    const desiredScrollX = slidePosition + Math.round(this.$slider.scrollLeft);

    this.$slider.scrollTo({
      top: 0,
      left: desiredScrollX,
      behavior: 'smooth',
    });
  }

  _getCurrentSlideIndex() {
    const slideContainerOffsetX = Math.round(this.$slider.getBoundingClientRect().left);
    const $slides = this._getSlides();
    return (
      $slides
        .map(($slide) => {
          const slideOffsetX = Math.round($slide.getBoundingClientRect().left);
          return {
            $el: $slide,
            offsetX: slideOffsetX - slideContainerOffsetX,
          };
        })
        .filter(({ offsetX }) => offsetX <= 0).length - 1
    );
  }

  _getSlides() {
    return [...this.fnSelectSlides({ $slider: this.$slider })];
  }
}
